import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Municipality } from '@/models/municipality.model';

class MunicipalitysService extends BaseService {
  private url: string = '/api/municipality';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<Municipality>> {
    const res = await this.$http.get<Municipality>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<Municipality[]>> {
    const res = await this.$http.get<Municipality[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(
    item: Partial<Municipality>,
  ): Promise<DataResponse<Municipality>> {
    const res = await this.$http.post<Municipality>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(item: Municipality): Promise<DataResponse<Municipality>> {
    const res = await this.$http.put<Municipality>(
      `${this.url}/${item.id}`,
      item,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new MunicipalitysService();
